<template>
    <div class="hooper-container">
        <div @click.prevent="slidePrev" class="hooper-controls">
            <chevron-up-icon size="1.5x" class="custom-class"></chevron-up-icon>
        </div>

        <div class="hooper-slider">
            <hooper
                    ref="carousel"
                    @slide="updateCarousel"
                    :style="'height: 100%'"
                    :vertical="true"
                    :itemsToShow="4"
                    :infiniteScroll="true"

            >
                <slide>
                    <div class="slide">
                        <img :src="require('@/assets/img_site/slide2_main.svg')" alt="">
                    </div>
                </slide>
                <slide>
                    <div class="slide">
                        <img :src="require('@/assets/img_site/slide2_main.svg')" alt="">
                    </div>
                </slide>
                <slide>
                    <div class="slide">
                        <img :src="require('@/assets/img_site/slide2_main.svg')" alt="">
                    </div>
                </slide>
                <slide>
                    <div class="slide">
                        <img :src="require('@/assets/img_site/slide2_main.svg')" alt="">
                    </div>
                </slide>
                <slide>
                    <div class="slide">
                        <img :src="require('@/assets/img_site/slide2_main.svg')" alt="">
                    </div>
                </slide>
                <navigation slot="hooper-addons"></navigation>
            </hooper>
        </div>

        <div @click.prevent="slideNext" class="hooper-controls">
            <chevron-down-icon size="1.5x" class="custom-class"></chevron-down-icon>
        </div>
    </div>
</template>

<script>
    import { ChevronUpIcon, ChevronDownIcon } from 'vue-feather-icons'

    import { Hooper, Slide, Navigation } from 'hooper';
    import 'hooper/dist/hooper.css';

    export default {
        name: "VerticalSlider",
        components: {
            ChevronUpIcon,
            ChevronDownIcon,
            Hooper,
            Slide,
            Navigation
        },
        data() {
            return {}
        },
        watch: {
            carouselData () {
                this.$refs.carousel.slideTo(this.carouselData);
            }
        },
        methods: {
            slidePrev() {
                this.$refs.carousel.slidePrev();
            },
            slideNext() {
                this.$refs.carousel.slideNext();
            },
            updateCarousel(payload) {
                this.myCarouselData = payload.currentSlide;
            }
        }
    };
</script>

<style scoped lang="scss">
    .hooper-navigation {
        display: none;
    }
    .hooper {
        &-container {
            display: flex;
            flex-direction: column;
            height: 100%;
            max-width: 85px;
            width: 100%;
            margin-right: 32px;
        }

        &-slider {
            flex: 1;
            display: flex;


        }
        &-controls {
            margin: 5px auto;
            svg {
                color: #3FB0AB;
            }
        }
    }
    .slide {
        background: #FFFFFF;
        width: 72px;
        height: 72px;
        margin: 8px auto 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        cursor: pointer;

        img {
            display: block;
            max-height: 100%;
            max-width: 100%;

        }
    }
</style>
